import { Slide, Typography, Grid, Link } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { selectUserInfo } from '../../features/userInfo/userInfoSlice';
import React from 'react'
import colors from '../colors';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate, useLocation }  from "react-router-dom";
import OTPInput from "otp-input-react";
import { sendGeneralRequest } from '../../features/generalRequest'
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik'
import * as yup from 'yup'
import {selectLoginState, setIsOtpSuccessfullyResent, setShouldDisplayTwoFactorAuth} from '../../features/login/loginSlice'
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../icons/lottieAnimations/smallLoading.json'
import {texts} from '../general/texts'
import { makeStyles } from '@mui/styles';
import Timer from '../general/Timer';
import { setGeneralMessage } from '../../features/global/globalDataSlice';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const validationSchema = yup.object({
  otp: yup
    .string()
    .length(4)
    .required()
});   

export const TwoFactorAuthentication = () => {

  const dispatch = useDispatch()
  const loginSliceState = useSelector(selectLoginState)
  const [shouldDisplayResendOtp, setShouldDisplayResendOtp] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState(false);



  React.useEffect(()=>{
    loginSliceState.shouldDisplayTwoFactorAuth && setIsOpen(true)
    !loginSliceState.shouldDisplayTwoFactorAuth && setIsOpen(false)
   },[loginSliceState.shouldDisplayTwoFactorAuth])

   React.useEffect(()=>{
    if(loginSliceState.isOtpSuccessfullyResent)
        {
            dispatch(setGeneralMessage({type: loginSliceState.success === true ? 'success' : 'error', message: loginSliceState.success === true && texts["message-otp-resend-success"]}))
            dispatch(setIsOtpSuccessfullyResent(false))
            setShouldDisplayResendOtp(false)
        }
   },[loginSliceState.isOtpSuccessfullyResent])

   const formik = useFormik({
      initialValues: {
          otp: '',
          token: '',
          type: ''
      },
     validationSchema: validationSchema,
     onSubmit: values => {
         dispatch(sendGeneralRequest({request: {_request: {...values, token: loginSliceState.token}}, baseUrlKey:'auth', endpoint: 'ValidateOtpGeneric'}))
     }
 })

  const handleOtpChange = (otp) => 
  {
    formik.setFieldValue('otp', otp)
  }

  const useStyles = makeStyles({
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "10px",
        height:"50%",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: '#FFFFFF',
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        borderRadius: "10px",
        maxHeight:'50%'
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
      },
        maxHeight:'700px',
        overflow:'auto',
        marginTop:1,
    }
  })

  const classes = useStyles()


  return (
    <Grid>
        <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {dispatch(setShouldDisplayTwoFactorAuth(false))}}
        fullScreen={true}
        PaperProps={{style: { borderRadius: '20px', marginTop:'10%'}}}
        aria-describedby="alert-dialog-slide-description"
        >
        <Grid container justifyContent={'right'} pt={4} pr={4} >
          <Button onClick={() => {dispatch(setShouldDisplayTwoFactorAuth(false))}} sx={{borderRadius:'50px', ":hover":{background:colors.lightOrange}}} >
            <CloseIcon color={'warning'} />
          </Button>
        </Grid>
      <DialogTitle mt={2} sx={{color:colors.darkBlue, textAlign:'center', fontFamily:'GerberaBold', fontSize:'2rem'}} >{texts["title-phone-verification"]}</DialogTitle>
        <DialogContent  >
          <Typography sx={{color:colors.gray, textAlign:'center', fontFamily:'GerberaMedium'}} id="alert-dialog-slide-description">
            {texts["message-subtitle-phone-verification"]}
          </Typography>
          <Grid container item md={12} xs={12} justifyContent={'center'} alignItems={'center'} className={classes.scrollBar}  sx={{position: 'fixed', bottom: 50}}>
            <Grid container item md={12} xs={12} alignItems={'center'} justifyContent={'center'} mr={2} >
              <OTPInput inputStyles={{borderTop:'none', width:'50px' ,borderLeft:'none', outline:'none', borderRight:'none', borderBottomColor:colors.orange, color:colors.darkBlue, fontSize:'2rem', paddingBottom:'3%', height:'68%' }} value={formik.values.otp} onChange={handleOtpChange} autoFocus OTPLength={4} otpType="number" disabled={false} />
            </Grid>
            <Grid container justifyContent={'center'} alignItems={'center'} direction={'column'} mr={4} >
                <Grid container item md={12} xs={12} justifyContent={'center'} alignItems={'center'} direction={'column'} mt={5} rowSpacing={3} >
                    <Grid item md={12} xs={12} >
                      {shouldDisplayResendOtp
                       ? <Link onClick={() => {dispatch(sendGeneralRequest({request: {token: loginSliceState.token, type: ''}, baseUrlKey:'auth', endpoint: 'ResendOtpGeneric'}))}} type="button" sx={{fontFamily:'GerberaBold', color: colors.darkBlue}} component="button" underline="none" variant="overline">{texts["message-resend-otp"]}</Link>
                       : <Grid container item md={12} xs={12} >
                            <Typography sx={{fontFamily:'GerberaBold', color: colors.darkBlue, marginRight:1}}>{texts["message-resend-otp-timer"]}</Typography>
                            <Timer duration={2 * 60 * 1000} onTimerCompleted={(value) => setShouldDisplayResendOtp(value)}/>
                          </Grid>
                       }
                    </Grid>
                    <Grid item md={12} xs={12} mb={2} >
                        <Button disabled={loginSliceState.isLoading ? true : false} onClick={formik.handleSubmit} sx={{background:colors.gradientOrange, color:colors.white, fontFamily:'GerberaBold'}} variant='button' >{texts["button-continue"]}</Button>
                    </Grid>
                </Grid>
                <Grid container item md={12} xs={12} justifyContent={'center'} >
                    <Grid container item md={0.8} xs={0.8} >
                        {loginSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
                    </Grid>
                </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
export default TwoFactorAuthentication